import { getBrandName, getBrandSlogan } from '@/libs/helper'

// eslint-disable-next-line import/prefer-default-export
export const brandName = {
  methods: {
    getBrandName() {
      let bn
      if (this.$i18n) {
        bn = getBrandName(this.$i18n.locale)
      }
      return bn
    },
    getBrandSlogan() {
      let slogan
      if (this.$i18n) {
        // Example: you might have a helper similar to getBrandName
        slogan = getBrandSlogan(this.$i18n.locale)
      }
      return slogan
    },
  },
}
